import NZ_Ochardised_One from "../../../assets/images/NZ_Ochardised_One.png";
import NZ_Ochardised_Two from "../../../assets/images/NZ_Ochardised_Two.png";
import NZ_Ochardised_Three from "../../../assets/images/NZ_Ochardised_Three.png";
import NZ_Ochardised_Four from "../../../assets/images/NZ_Ochardised_Four.png";
import NZ_Ochardised_Five from "../../../assets/images/NZ_Ochardised_Five.png";
import NZ_Ochardised_Six from "../../../assets/images/NZ_Ochardised_Six.png";
const NzOrchardisedModels = () => {
    return (
        <div className="bg-white pt-[20px] pb-[45px]">
            <div className="custom-container px-[30px] text-start mx-auto ">
                <div className="max-w-[1200px]  mx-auto">
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-5 max-w-[1400px] mx-auto">
                        <img
                            src={NZ_Ochardised_One}
                            alt=""
                            className="w-full h-[260px] object-cover"
                        />
                        <img
                            src={NZ_Ochardised_Two}
                            alt=""
                            className="w-full h-[260px] object-cover"
                        />
                        <img
                            src={NZ_Ochardised_Three}
                            alt=""
                            className="w-full h-[260px] object-cover"
                        />
                        <img
                            src={NZ_Ochardised_Four}
                            alt=""
                            className="w-full h-[260px] object-cover"
                        />
                        <img
                            src={NZ_Ochardised_Five}
                            alt=""
                            className="w-full h-[260px] object-cover"
                        />
                        <img
                            src={NZ_Ochardised_Six}
                            alt=""
                            className="w-full h-[260px] object-cover"
                        />
                    </div>

                </div>
            </div>
        </div>
    );
};
export default NzOrchardisedModels;
